import blog1 from "../../assets/blog1.webp";
import blog2 from "../../assets/blog2.webp";
import blog3 from "../../assets/blog3.webp";
import blog4 from "../../assets/blog4.webp";
import blog5 from "../../assets/blog5.webp";
import blog6 from "../../assets/blog6.webp";

const blogData = [
  {
    id: 1,
    img: blog5,
    alt: "Man working out in a fitness studio",
    month: "November",
    title: "TIPS TO OPTIMIZE YOUR GYM ROUTINE",
    text: "Enhance your workout efficiency with expert advice on maximizing gym time and achieving your fitness objectives.",
  },
  {
    id: 2,
    img: blog4,
    alt: "Woman performing strength exercises",
    month: "October",
    title: "THE ULTIMATE GUIDE TO FITNESS SUCCESS",
    text: "Uncover key strategies and insights with this comprehensive guide to conquering your fitness journey.",
  },
  {
    id: 3,
    img: blog6,
    alt: "Woman lifting weights at the gym",
    month: "October",
    title: "BOOST YOUR MIND AND BODY WITH FITNESS",
    text: "Explore how staying active can sharpen your mind and uplift your mood for a healthier lifestyle.",
  },
  {
    id: 4,
    img: blog2,
    alt: "Man engaged in endurance training",
    month: "September",
    title: "WHY TODAY IS PERFECT FOR FITNESS",
    text: "Don't wait for tomorrow—start your fitness transformation today and embrace a healthier you.",
  },
  {
    id: 5,
    img: blog1,
    alt: "Woman performing bodyweight exercises",
    month: "September",
    title: "PERSONAL TRAINING: GETTING STARTED",
    text: "Take the first step in your personal fitness journey with essential tips for beginners.",
  },
  {
    id: 6,
    img: blog3,
    alt: "Man training like a professional athlete",
    month: "August",
    title: "TRAIN LIKE A CHAMPION ATHLETE",
    text: "Adopt the training routines of elite athletes and unlock your peak performance potential.",
  },
];

export default blogData;
